import './MainHint.css'

export const MainHint = ({ text }: { text: string }) => {
	return (
		<div className="main-hint">
			<p className="main-hint-text">{text}</p>
		</div>
	)
}